import { render, staticRenderFns } from "./Tester.vue?vue&type=template&id=244d4e58&scoped=true"
import script from "./Tester.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tester.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Tester.vue?vue&type=style&index=0&id=244d4e58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d4e58",
  null
  
)

export default component.exports